<template>
  <form class="space-y-3 -mt-4" @submit.prevent="handleContinue">
    <h1
      class="text-2xl font-extralight text-gray-200 flex justify-center text-center font-mind-force"
    >
      Acesso seguro
    </h1>

    <div class="space-y-8">
      <div v-if="company" class="text-center">
        <p class="text-sm text-gray-500">Empresa</p>
        <p class="text-gray-200 font-medium mt-1">
          {{ company.trade_name }}
        </p>
      </div>

      <div>
        <select
          v-model="selectedRoleId"
          class="w-full bg-transparent border-b border-gray-600 focus:border-red-500 focus:outline-none py-2 text-gray-200 transition-all duration-300 text-center"
        >
          <option disabled value="">Selecione sua função</option>
          <option
            v-for="role in sortedSectors"
            :key="role.id"
            :value="role.id"
            class="bg-[#1c1f26] text-white"
          >
            {{ role.name }}
          </option>
        </select>
      </div>

      <p v-if="errorMessage" class="text-sm text-red-400 text-center">
        {{ errorMessage }}
      </p>

      <button
        type="submit"
        :disabled="loading"
        class="w-full bg-red-600 hover:bg-red-700 transition-all py-3 rounded-lg text-white font-medium shadow-lg disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {{ loading ? "Entrando..." : "Entrar" }}
      </button>
    </div>
  </form>
</template>

<script setup>
import { onMounted, computed, ref } from "vue";
import { useRouter } from "vue-router";
import { issueDeviceId } from "@/services/public/publicFormService";
import {
  getCollaboratorInviteContext,
  setCollaboratorRoleContext,
  getCollaboratorDoneKey,
} from "@/services/public/collaboratorSessionService";

const router = useRouter();

const inviteContext = getCollaboratorInviteContext();

const company = computed(() => inviteContext?.company || null);
const roles = computed(() => inviteContext?.roles || []);

const selectedRoleId = ref("");
const loading = ref(false);
const errorMessage = ref("");

const doneKey = computed(() =>
  getCollaboratorDoneKey(inviteContext?.invite_token)
);

const sortedSectors = computed(() => {
  return [...roles.value].sort((a, b) => {
    return a.name.localeCompare(b.name, 'pt-BR', {
      sensitivity: 'base'
    })
  })
})

onMounted(() => {
  if (localStorage.getItem(doneKey.value) === "1") {
    router.replace({ name: "collab-form" });
  }
});

async function handleContinue() {
  errorMessage.value = "";

  if (!selectedRoleId.value) {
    errorMessage.value = "Selecione seu setor.";
    return;
  }

  loading.value = true;

  try {
    let deviceId = localStorage.getItem("xsm_device_id");

    if (!deviceId) {
      const { data } = await issueDeviceId();
      deviceId = data.device_id;
      localStorage.setItem("xsm_device_id", deviceId);
    }

    const role = roles.value.find((item) => item.id === selectedRoleId.value);

    setCollaboratorRoleContext({
      role_id: selectedRoleId.value,
      role_name: role?.name || "",
      device_id: deviceId,
    });

    router.push({ name: "collab-form" });
  } catch (error) {
    errorMessage.value =
      error?.response?.data?.message || "Não foi possível continuar.";
  } finally {
    loading.value = false;
  }
}
</script>
